import React from "react";
import contract from "../assets/undraw_Agreement_re_d4dv.png";
import { useNavigate } from "react-router-dom";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Box,
    Typography,
    useTheme,
} from "@mui/material";
import { updateContract } from "state/apis";

const Renew = ({ open, onClose, onSubmit, editData, editMode, balance }) => {
    const theme = useTheme();

    const handleSubmit = async () => {
        onSubmit();
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth={"sm"}>
            <DialogTitle sx={{ textAlign: "center", fontWeight: "900", mb: "2px" }}>
                Confirmation
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={3} p={"5px"}>
                    <Grid item xs={12} container direction="column" alignItems="center">
                        <Box
                            component="img"
                            alt="select"
                            src={contract}
                            height="200px"
                            width="200px"
                            sx={{ objectFit: "cover" }}
                        />
                        <Typography variant="body1" mt={2} textAlign={"center"}>
                            {balance === 0
                                ? " Are You Sure Want To Renew Contract ?"
                                : `You have balance of ${balance}, do you want to proceed?`}
                        </Typography>
                    </Grid>
                </Grid>

                <DialogActions sx={{ justifyContent: "center" }}>
                    <Button
                        variant="contained"
                        onClick={onClose}
                        sx={{
                            color: theme.palette.primary.light,
                            backgroundColor: theme.palette.secondary[200],
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleSubmit}
                        sx={{
                            color: theme.palette.primary.light,
                            backgroundColor: theme.palette.secondary[200],
                        }}
                    >
                        Proceed
                    </Button>
                </DialogActions>
            </DialogContent>
        </Dialog>
    );
};

export default Renew;
